export function initFilterForm() {
  const formEl = document.querySelector("#filter-form")
  const countObjectEl = document.querySelector("#filter-count")
  if (!formEl || !countObjectEl) return

  const countObject = JSON.parse(countObjectEl.textContent)

  for (const input of formEl.querySelectorAll(
    ".field--filtercheckboxselectmultiple input",
  )) {
    const fieldset = input.getAttribute("name")
    const value = input.value

    const count = countObject[fieldset][value]
    input.closest("label").setAttribute("data-count", count ? count : 0)
  }

  const yearFromInput = document.querySelector("#id_ff-year_from")
  const yearUntilInput = document.querySelector("#id_ff-year_until")
  if (yearFromInput && yearUntilInput) {
    yearFromInput.addEventListener("change", (e) => {
      const currentValue = e.target.value
      if (yearUntilInput.value < currentValue)
        yearUntilInput.value = currentValue
      for (const opt of yearUntilInput.children) {
        opt.toggleAttribute("disabled", opt.value < currentValue)
      }
    })
  }

  formEl.addEventListener("click", (e) => {
    const zeroInput = e.target?.closest(".filterToggle[data-count='0']")
    if (zeroInput) {
      const checkedInput = e.target.closest("input")
      if (checkedInput) checkedInput.removeAttribute("checked")
    }
  })

  /* sort labels, rough in backend */
  for (const fieldset of formEl.querySelectorAll(".filterTogglesList")) {
    const divs = Array.from(fieldset.querySelectorAll("div:has(.filterToggle)"))
    divs.sort((a, b) => {
      const labelA = a.querySelector("label").textContent.trim()
      const labelB = b.querySelector("label").textContent.trim()
      return labelA.localeCompare(labelB)
    })
    fieldset.append(...divs)
  }
}
